import { LicenseName } from "@/data/license.data";

export abstract class ServiceUsingDurationLimiter {
  abstract getPlanUsingDurationLimit(
    license: LicenseName,
    duration: number,
  ): number;
}
